import { createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit';

import { NotificationOption } from '~/components/Notification';

export interface NotificationState {
  option: NotificationOption | null;
}

const initialState: NotificationState = {
  option: null,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setOption: (state, action: PayloadAction<NotificationState['option']>) => {
      state.option = action.payload;
    },
  },
});

export const notificationReducer = notificationSlice.reducer;
export const { setOption } = notificationSlice.actions;
